import { AccountsListService } from './../../../services/accounts/accounts-list.service';
import { OnlineService } from 'src/app/services/general/online.service';
import { NavigationExtras, Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { TranslateService } from '@ngx-translate/core';

import { UserService } from 'src/app/services/user/user.service';
import { UpdateByService } from 'src/app/services/user/update-by.service';
import { ErrorService } from 'src/app/services/general/error.service';
import { PopupService } from 'src/app/services/general/popup.service';
import { UserAccounts } from 'src/app/interfaces/account';
import { Subscription } from 'rxjs';
import { AnalyticsService } from 'src/app/services/general/analytics.service';

@Component({
  selector: 'app-user-delete',
  templateUrl: './user-delete.page.html',
  styleUrls: ['./user-delete.page.scss'],
})
export class UserDeletePage implements OnInit, OnDestroy {

  ownAccountList: UserAccounts[];

  private accountListSubscription: Subscription;

  /**
   * Constructor
   * @param router router
   * @param translate translate service
   * @param fns angualr firestore function
   * @param userService user service
   * @param updateByService update by service
   * @param popupService popup service
   */
  constructor(
    private router: Router,
    private translate: TranslateService,
    private analyticsService: AnalyticsService,
    private fns: AngularFireFunctions,
    private userService: UserService,
    private accountListService: AccountsListService,
    private updateByService: UpdateByService,
    private onlineService: OnlineService,
    private popupService: PopupService,
    private errorService: ErrorService,
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.unwatchAccountList();
  }

  ionViewWillEnter() {
    this.watchAccountList();
  }

  ionViewWillLeave() {
    this.unwatchAccountList();
  }

  watchAccountList() {
    if (!this.accountListSubscription) {
      this.accountListSubscription = this.accountListService.observableUserAccountsList.subscribe(() => {
        this.ownAccountList = this.getOwnAccountList();
      });
    }
  }

  unwatchAccountList() {
    if (this.accountListSubscription) {
      this.accountListSubscription.unsubscribe();
      this.accountListSubscription = null;
    }
  }

  getOwnAccountList(): UserAccounts[] {
    return this.accountListService.getOwnAccount();
  }
  /**
   * Confirm delete user account
   */
  async confirmDeleteUserAccount() {
    const input = await this.popupService.presentInput(
      this.translate.instant('USER.delete.title'),
      '',
      this.translate.instant('USER.delete.msg.confirm'),
      '',
      '',
      false,
      'delete',
      'delete',
      this.translate.instant('CRUD.delete'),
      '',
      this.translate.instant('CRUD.delete')?.toString().toLowerCase()
    );
    input.onWillDismiss().then((result: any) => {
      if (result?.data?.input) {
        if (result?.data?.input === this.translate.instant('CRUD.delete')?.toString().toLowerCase()) {
          this.deleteUserAccountCall(this.userService.uid);
        } else {
          this.confirmDeleteUserAccount();
        }
      }
    });
  }

  /**
   * Delete user action fns call
   * @param uid User ID
   */
  async deleteUserAccountCall(uid: string) {
    if (this.onlineService.isOnline()) {
      const updateBy = this.updateByService.getUpdateBy();
      if (uid && updateBy?.uid) {
        await this.popupService.presentLoading();
        this.fns.httpsCallable('deleteUserAccountCall')({ uid, updateBy })
        .toPromise().then(async (result: boolean) => {
          if (result) {
            this.analyticsService.userDelete(uid);
            this.goUserLogout();
          } else {
            this.popupService.presentAlert(this.translate.instant('USER.delete.msg.error'));
          }
          this.popupService.dismissLoading();
        }).catch((err) => {
          this.errorService.logError(err);
          this.popupService.dismissLoading();
          this.popupService.presentAlert(this.translate.instant('USER.delete.msg.error'));
        });
      } else {
        this.popupService.presentActionError();
      }
    }
  }

  /**
   * Go user profile
   */
  goUserProfile() {
    const navigationExtras: NavigationExtras = {
      state: { type: 'account' }
    };
    this.router.navigate(['/user/profile'], navigationExtras);
  }

  /**
   * Go user logout
   */
  goUserLogout() {
    this.router.navigate(['/user/logout']);
  }

}
